// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLanguage } from "../lib/storeManager";
import { ensureReady } from "./i18nLoader";

i18n.use(initReactI18next).init(
  {
    lng: getLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    load: "languageOnly",
    ns: ["common"],
    defaultNS: "common",
  },
  async err => {
    if (!err) {
      try {
        const currentLanguage = getLanguage();
        await ensureReady({ lng: currentLanguage, nsList: ["common"] });
      } catch (error) {
        console.error("Failed to load default translations:", error);
      }
    }
  }
);

export default i18n;
